//About page view
import Barba from 'barba.js'
//Progressive from

const About = Barba.BaseView.extend({
  namespace: 'about',
  screenWidth: window.innerWidth,
  onEnter(){

  },
  onEnterCompleted(){

  },
  onLeave(){
    this.destroy();
  },
  $el: null,
  _construct(){
  },
  destroy(){

  }
});
export default About;



// WEBPACK FOOTER //
// ./source/scripts/modules/barbaviews/about.js